import React, { useMemo } from 'react';
import { useFragment } from 'react-relay/hooks';

import { graphql } from 'babel-plugin-relay/macro';
import { Typography, TypographyProps } from 'embeds/components';
import moment from 'moment';

import { TypographyNodeDob_EmbedNode$key } from './__generated__/TypographyNodeDob_EmbedNode.graphql';

export interface TypographyNodeDobProps extends Omit<TypographyProps, 'classes' | 'children'> {
  fragmentRef: TypographyNodeDob_EmbedNode$key;
  format?: string;
}

const TypographyNodeDob: React.FC<TypographyNodeDobProps> = ({ fragmentRef, format = 'L', ...rest }) => {
  const node = useFragment<TypographyNodeDob_EmbedNode$key>(
    graphql`
      fragment TypographyNodeDob_EmbedNode on Node {
        ... on Patient {
          dateOfBirth {
            day
            month
            year
          }
        }
        ... on Provider {
          dateOfBirth {
            day
            month
            year
          }
        }
        ... on User {
          dateOfBirth {
            day
            month
            year
          }
        }
      }
    `,
    fragmentRef,
  );

  const children = useMemo(() => {
    if (!node || !node.dateOfBirth) {
      return null;
    }
    const {
      dateOfBirth: { year, month, day },
    } = node;
    if (!year || !month || !day) {
      return null;
    }
    return moment()
      .year(year)
      .month(month - 1)
      .date(day)
      .format(format);
  }, [node, format]);

  if (!children) {
    return null;
  }
  return (
    <Typography variant="inherit" color="inherit" {...rest}>
      {children}
    </Typography>
  );
};

export default TypographyNodeDob;
